/**
 * Centralized tab and section labels for the project detail page.
 * Used for navigation tabs and section headings (mobile-friendly short labels).
 */
export const PROJECT_DETAIL_TABS = {
  info: "Informações",
  diary: "Diário",
  financial: "Financeiro",
  documents: "Documentos",
} as const;

export const PROJECT_DETAIL_SECTION_TITLES = {
  diary: "DIÁRIO",
  financial: "FINANCEIRO",
} as const;
